/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getWorkflowList(payload) {
        return HttpService.post(environment.API_WORKFLOW + '/search', payload);
    },
    getDepartmentAll() {
        return HttpService.get(environment.API_DEPARTMENT_ALL)
    },
    getWorkflowListDropdown(payload) {
        return HttpService.post(environment.API_WORKFLOW + '/dropdown', payload);
    },
    getWorkflow(work_flow_id) {
        return HttpService.get(environment.API_WORKFLOW + '/detail/' + work_flow_id)
    },
    updateWorkflow(payload, workflowId) {
        return HttpService.put(environment.API_WORKFLOW + `/detail/${workflowId}`, payload);
    },
    workflowInactive(workflowId) {
        return HttpService.patch(environment.API_WORKFLOW + `/inactive/${workflowId}`);
    }
};
